import { render, staticRenderFns } from "./Cruuency.vue?vue&type=template&id=54d0d9f2"
import script from "./Cruuency.vue?vue&type=script&lang=js"
export * from "./Cruuency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports